import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {IAuthData} from '../models/IAuthData';
import {Store} from '@ngrx/store';
import {IAppState} from '../models/IAppState';
import {authorize} from '../store/actions/user.actions';
import {saveToLocalStorage} from '../store/actions/store.actions';
import {Router} from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AuthWithPushNotificationService {

  constructor(private http: HttpClient,
              private router: Router,
              private store: Store<{AppStateReducer: IAppState}>) {
  }

  public loginWithPhoneNumberAndDeviceUuid(phoneNumber: string, deviceUuid: string): Observable<IAuthData> {
    const params = `${phoneNumber}/${deviceUuid}/${environment.authClientId}`;
    return this.http.post<IAuthData>(`${environment.loginUrl}/user/loginWithPhoneNumberAndDeviceUuid/${params}`, {});
  }

  public isRegistrationRequestConfirmed(phoneNumber: string, deviceUuid: string): Observable<boolean> {
    const params = `${phoneNumber}/${deviceUuid}`;
    return this.http.get<boolean>(`${environment.loginUrl}/user/isRegistrationRequestConfirmed/${params}`);
  }

  async logout(foreground: boolean) {
    this.store.dispatch(authorize({isAuthorised: false, authData: null}));
    this.store.dispatch(saveToLocalStorage());
    localStorage.removeItem('cometChatToken');
    await new Promise((res) => setTimeout(() => res(null), 1));
    if (!foreground) {
      if (this.router.url !== '/login') {
        this.router.navigate(['/login'], {replaceUrl: true});
        window.location.reload();
      }
    }
  }
}
